export const doubleListA11yHackerStyles = () => ({
  '& .a11y-adapter-list': {
    outline: 'none',
  },
  '& .a11y-adapter-item': {
    '&.a11y-adapter-item-focused': {
      border: '1px solid #605e5c',
    },
    '&.a11y-adapter-item-selected': {
      background: '#edebe9',
    },
  },
});
